<template>
  <section class="page-section">
        <!-- step -->
        <div class="page-step">
          <div class="page-step-content real">
            <div class="page-step-name flex-h">
              <div class="flex-a-i" :class="{ 'current-step': infoData.status >= 2 }">客户确认预约</div>
              <div class="flex-a-i" :class="{ 'current-step': infoData.status >= 3 }">订单完成</div>
            </div>
            <div class="page-step-icon flex-h">
              <div class="step-icon-box flex-a-i">
                <div class="step-icon" :class="{ 'current-step': infoData.status >= 2 }">
                  <i class="el-icon-check" v-if="infoData.status >= 2"></i>
                </div>
              </div>
              <div class="step-icon-box flex-a-i">
                <div class="step-icon" :class="{ 'current-step': infoData.status >= 3 }">
                  <i class="el-icon-check" v-if="infoData.status >= 3"></i>
                </div>
              </div>
              <div class="step-line-box flex-h">
                <div class="step-line flex-a-i" :class="{ 'current-step': infoData.status >= 3 }"></div>
              </div>
            </div>
            <div class="page-step-time flex-h">
              <div class="flex-a-i">{{ infoData.createDate }}</div>
              <div class="flex-a-i">{{ infoData.createDate }}</div>
            </div>
          </div>
        </div>

        <!-- info -->
        <el-form size="small" label-width="80px" class="content-form no-padding-bottom detail-content">
          <div class="form-module">
            <div class="module-header">订单信息</div>
            <div class="detail-body">
              <div class="detail-item flex-h">
                <p class="title">订单号：</p>
                <p class="flex-a-i">{{ infoData.orderNo }}</p>
              </div>
              <div class="detail-item flex-h">
                <p class="title">订单状态：</p>
                <p class="flex-a-i">
                  <span v-if="infoData.status == 2">已预约</span>
                  <span v-if="infoData.status == 3">已完成</span>
                  <span v-if="infoData.status == 4">已取消</span>
                </p>
              </div>
              <div class="detail-item flex-h">
                <p class="title">客户：</p>
                <p class="flex-a-i">{{ infoData.customerName }}，{{ infoData.sex == 1 ? '男' : '女' }}，{{ infoData.age }}
                </p>
              </div>
              <div class="detail-item flex-h">
                <p class="title">手机号：</p>
                <p class="flex-a-i">{{ infoData.mobile }}</p>
              </div>
              <div class="detail-item flex-h">
                <p class="title">其他要求：</p>
                <p class="flex-a-i">{{ infoData.remark }}</p>
              </div>
            </div>
          </div>
        </el-form>

        <!-- table -->
        <div class="table-region" v-if="infoData != {}">
          <!-- 自定义表格 -->
          <div class="custom-table">
            <div class="custom-table-header">
              <el-row :gutter="10">
                <el-col :span="7">
                  <div class="table-cell">项目</div>
                </el-col>
                <el-col :span="3">
                  <div class="table-cell">价格</div>
                </el-col>
                <!-- <el-col :span="3"><div class="table-cell">会员权益</div></el-col> -->
                <el-col :span="3">
                  <div class="table-cell">实付金额</div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell">预约时间</div>
                </el-col>
                <el-col :span="4">
                  <div class="table-cell">预约门店</div>
                </el-col>
                <el-col :span="3">
                  <div class="table-cell">客户</div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell">订单状态</div>
                </el-col>
              </el-row>
            </div>

            <div class="custom-table-body">
              <div class="table-row" v-for="(item, index) in infoData.serviceOrderItemVOS" :key="item.id || index">
                <div class="order-list-item">
                  <div class="item-body">
                    <el-row :gutter="10">
                      <el-col :span="7">
                        <div class="table-cell">
                          <div class="table-cell">
                            <div class="goods-title">
                              <div class="thumb-wrap">
                                <img :src="item.servicePic || require('@/assets/default.png')">
                              </div>
                              <p>{{ item.serviceName }}</p>
                              <p>备注：{{ item.remark || '-' }}</p>
                            </div>
                          </div>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="table-cell">
                          <p class="text">￥{{ item.price }}</p>
                          <p class="text">₩{{ item.koreaPrice }}</p>
                        </div>
                      </el-col>
                      <!-- <el-col :span="3"><div class="table-cell">
                          <p class="text" v-if="item.discount">{{ item.discount }}折</p>
                      </div></el-col> -->
                      <el-col :span="3">
                        <div class="table-cell">
                          <p class="text" v-if="item.actualPayment">￥{{ item.actualPayment }}</p>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="table-cell">
                          <p class="text">{{ COMMON.formatDate('2', '-', item.payTime) }}</p>
                        </div>
                      </el-col>
                      <el-col :span="4">
                        <div class="table-cell">
                          <p class="text">{{ infoData.shopName }}</p>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <div class="table-cell">
                          <p class="text">{{ infoData.customerName }}</p>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="table-cell">
                          <p class="text" v-if="infoData.status == 2">已预约</p>
                          <p class="text" v-if="infoData.status == 3">已完成</p>
                          <p class="text" v-if="infoData.status == 4">已取消</p>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </section>
</template>

<script>
import { COMMON, serviceOrdersDetail } from '../../../common/api'

export default {
  data() {
    return {
      COMMON,

      id: this.$route.query.id || '', // 订单id
      tabName: this.$route.query.tabname || '',

      pageLoading: false,
      infoData: {}
    }
  },
  methods: {
    /**
     * [getData description] 获取数据
     * @return {[type]}     [description]
     */
    getData: function () {
      this.pageLoading = true;
      serviceOrdersDetail({
        orderId: this.id
      }).then(res => {
        this.pageLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          this.infoData = data;
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.pageLoading = false;
        this.$message.error('服务器异常');
      })
    }
  },
  mounted() {
    this.getData();
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

.table-statistics {
  border: 1px solid $separateDefaultColor;
  border-left: none;

  ::v-deep .el-row {
    padding: 0;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

.hover-link {
  color: $themeColor !important;
  cursor: pointer;

  &:hover {
    color: $darkLinkHoverColor !important;
  }
}

.mr-20 {
  margin-right: 20px;
}

.mt-10 {
  margin-top: 10px;
}

.reply-dialog {

  ::v-deep .el-dialog {
    min-width: 400px !important;
  }

  .reply-textarea {
    position: relative;

    .reply-count {
      position: absolute;
      right: 15px;
      bottom: 5px;
      line-height: 18px;
      color: $tipsDisabledColor;
    }
  }
}

.text-area {

  ::v-deep .el-textarea__inner {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}

.page-step {
  padding: 20px 0;
  background: $colorPageBg;
  font-size: $smallFS;
  color: $textColor;

  .page-step-content {
    margin: 0 auto;
    text-align: center;

    &.real {
      width: 380px;

      .step-line-box {
        width: 190px;
      }
    }

    &.virtual {
      width: 380px;

      .step-line-box {
        width: 190px;
      }
    }

    .page-step-name {
      margin-bottom: 10px;

      .current-step {
        color: #3EC1DA;
      }
    }

    .page-step-icon {
      position: relative;
      margin-bottom: 10px;

      .step-icon-box {

        .step-icon {
          @include position(relative, 1, none, none, none, none);
          margin: 0 auto;
          width: 24px;
          height: 24px;
          border-radius: 12px;
          background: $borderDefaultColor;

          &.current-step {
            background: #5BCFE6;
          }

          i {
            font-size: 16px;
            line-height: 24px;
            text-align: center;
            color: #FFFFFF;
          }
        }
      }

      .step-line-box {
        @include position(absolute, 0, 50%, none, none, 50%);
        @include translate(-50%, -50%, 0);
        height: 3px;

        .step-line {
          background: $borderDefaultColor;

          &.current-step {
            background: #5BCFE6;
          }
        }
      }
    }
  }
}

.detail-content {
  color: $textColor;

  .detail-body {
    padding-top: 20px;
    font-size: $smallFS;

    .detail-item {
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      .title {
        width: 150px;
        text-align: right;
      }
    }
  }
}

.table-region {
  .custom-table {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .custom-table-header {
      flex-shrink: 0;
      padding-right: 4px;
      text-align: center;
      scrollbar-gutter: stable;
    }

    .custom-table-body {
      flex: 1;
      padding-right: 4px;
      overflow-y: overlay;
    }
  }

  .custom-table-footer {
    padding: 10px;
    font-size: $smallFS;

    .return-box {

      .return-title,
      .return-content {
        color: $textColor;
      }

      .return-status {
        flex: 0 0 30%;
        width: 30%;
        text-align: right;
        color: $compeleteColor;
      }
    }

    .return-time {
      margin-top: 10px;
      margin-left: 60px;
      color: $textColor;
    }
  }
}

.item-comment {
  padding: 10px;
  border: 1px solid $separateDefaultColor;
  border-top: none;
  font-size: $smallFS;

  .comment-first,
  .comment-second {
    flex: 0 0 45%;
    width: 45%;

    .img-wrap {
      @include alignItems(center);

      .img-box {
        display: inline-block;
        position: relative;
        width: 48px;
        height: 48px;
        background: $colorImgBg;

        &+.img-box {
          margin-left: 10px;
        }

        img {
          @include position(absolute, 1, 50%, none, none, 50%);
          max-width: 100%;
          max-height: 100%;
          @include translate(-50%, -50%, 0);
        }
      }
    }
  }

  .comment-first {

    .comment-first-time {
      display: inline-block;
      vertical-align: middle;
    }

    .comment-star {
      display: inline-block;
      margin-left: 20px;
    }
  }

  .comment-second {
    padding-left: 5px;

    .comment-second-day {
      color: $tipsColor;
    }
  }

  .comment-option {
    flex: 0 0 10%;
    width: 10%;
    text-align: right;
  }

  .item-reply {
    margin-top: 10px;

    .reply-title {
      color: $compeleteColor;
    }
  }
}

.goods-title {
  position: relative;
  padding-left: 58px;
  min-height: 48px;

  .thumb-wrap {
    @include position(absolute, 3, 50%, none, none, 0);
    width: 48px;
    height: 48px;
    margin-top: -24px;
    background-color: $colorPageBg;

    img {
      max-width: 100%;
      max-height: 100%;
      @include position(absolute, 1, 50%, none, none, 50%);
      @include translate(-50%, -50%, 0);
    }
  }

  p {
    line-height: 1.4;

    &+p {
      margin-top: 5px;
    }
  }
}
</style>
